'use client';

import { c as _c } from "react/compiler-runtime";
import { useUserSession } from '@libs/common-next';
import { CarouselContent } from './carousel-content';
type BuyItAgainProps = {
  readonly header: string;
  readonly subheader?: string;
};
export function BuyItAgain(t0) {
  const $ = _c(3);
  const {
    header,
    subheader
  } = t0;
  const {
    isAuthenticated,
    isSoftAuthenticated
  } = useUserSession();
  if (!isAuthenticated || isSoftAuthenticated) {
    return null;
  }
  let t1;
  if ($[0] !== header || $[1] !== subheader) {
    t1 = <CarouselContent header={header} subheader={subheader} />;
    $[0] = header;
    $[1] = subheader;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}